// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","455":"2c7cd7c4","977":"5d9c67ca"}[chunkId] + ".chunk.js";
};